import React from "react";
// import Header from "./Navbar/Navbar.tsx";
// import Footer from "./Footer/Footer.tsx";
import { Helmet } from "react-helmet";
import { Toaster } from "react-hot-toast";

const Layout = ({ children, title, description, keywords, author }) => {
  return (
    <>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Font Awesome CDN link for icons */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css"
        />
        <title>{title}</title>
      </Helmet>
      {/* <Header /> */}
      <main>
        <Toaster position="bottom-center" reverseOrder={false} />
        {children}
      </main>
      {/* <Footer /> */}
    </>
  );
};

Layout.defaultProps = {
  title: "Last Bite",
  description: "Food Donation Website",
  keywords: "Food Donation Website Last Bite",
  author: "Aman_Chandra",
};

export default Layout;
